(function() {
  var PRODUCTS = {
    'Electric Lime': '/products/cramp-killa-endurance-pack-electric-lime',
    'Sunburst Orange': '/products/cramp-killa-endurance-pack-sunburst-orange'
  };

  function setActive() {
    var path = window.location.pathname;
    document.querySelectorAll('.custom-selector-option input[type="radio"]').forEach(function(r) {
      r.checked = (PRODUCTS[r.value] === path);
    });
  }

  function bind() {
    setActive();
    document.querySelectorAll('.custom-selector-option label').forEach(function(label) {
      if (label.dataset.b) return;
      label.dataset.b = '1';
      label.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopImmediatePropagation();
        var input = document.getElementById(this.getAttribute('for'));
        if (!input) return;
        var url = PRODUCTS[input.value];
        if (url && window.location.pathname !== url) {
          window.location.href = url;
        }
      }, true);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bind);
  } else {
    bind();
  }
})();